import { CSSProperties, FC, useMemo, } from "react";
// 组件
import { ProImage, ProTooltip, } from '../antd';
import CopyText from '../CopyText';
// 方法
import classNames from "classnames";
import { renderValueHtml } from "./utils";
// 常量
import { GoodInfoColumnProps } from "./interface";
import './style.less';

/** 商品信息列 */
const GoodInfoColumn: FC<GoodInfoColumnProps> = props => {
  const { image, showImage, titlePrefix, title, copyTitle, options, style, className, width, } = props;
  const contaierClasses = useMemo(() => {
    return classNames('good-info-column-contaier', {
      'good-info-column-full': !showImage,
    });
  }, [showImage]);
  const wrapperClasses = useMemo(() => {
    return classNames('good-info-column', className);
  }, [className]);
  const wrapperStyle: CSSProperties = useMemo(() => {
    let newStyle: CSSProperties = {};
    if (style) newStyle = { ...style };
    if (width) {
      newStyle.width = width;
    }
    return newStyle;
  }, [style, width]);
  return (
    <div className={wrapperClasses} style={wrapperStyle}>
      {
        showImage && (
          <div className="good-info-column-img">
            <ProImage
              src={image}
              height={45}
            />
          </div>
        )
      }
      <div className={contaierClasses}>
        {
          !!title && (
            <div className="good-info-column-title">
              {
                !!titlePrefix && (
                  <div className="good-info-column-title-prefix">{titlePrefix}</div>
                )
              }
              <div className="good-info-column-title-text yb-line-ellipsis-1">
                {
                  (copyTitle && typeof title === 'string') ? <CopyText text={title} /> : <ProTooltip title={title}>{title}</ProTooltip>
                }
              </div>
            </div>
          )
        }
        {
          (Array.isArray(options) && !!options.length) && (
            <div className="good-info-column-info">
              {
                options?.map(item => {
                  const { label, singleRow, prefix, } = item;
                  if (singleRow) {
                    return (
                      <div className="good-info-column-info-item single-row">
                        {
                          prefix && (
                            <span>{prefix}</span>
                          )
                        }
                        {
                          !!label && <span className="good-info-column-info-item-title">{label}:</span>
                        }
                        {renderValueHtml(item)}
                      </div>
                    );
                  }
                  return (
                    <div className="good-info-column-info-item">
                      {
                        prefix && (
                          <span>{prefix}</span>
                        )
                      }
                      {
                        !!label && <span className="good-info-column-info-item-title">{label}:</span>
                      }
                      {renderValueHtml(item)}
                    </div>
                  );
                })
              }
            </div>
          )
        }
      </div>
    </div>
  );
};

GoodInfoColumn.defaultProps = {
  showImage: true,
  copyTitle: true,
};

export default GoodInfoColumn;
